import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import fusionOidc from 'src/fusionOidc'
import { rescindTos, getUserId } from 'src/utils/tosUtils'
import {
  CDropdown,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CDropdownDivider,
} from '@coreui/react'
import { cilList, cilUser, cilTrash } from '@coreui/icons'
import CIcon from '@coreui/icons-react'

const AppHeaderDropdown = () => {
  const user = useSelector((state) => state.user)
  const token = useSelector((state) => state.token)
  const navigate = useNavigate()
  const [isRescinding, setIsRescinding] = useState(false)

  const handleRescindTos = async () => {
    if (isRescinding) return

    try {
      setIsRescinding(true)
      // console.log('=== Rescinding TOS Agreement ===')
      // console.log('User:', user)
      // console.log('Token:', token)

      const userId = getUserId(user)
      // console.log('Using userId for rescinding:', userId)
      try {
        // Get user's IP address (for tracking purposes)
        let ipAddress = 'unknown'
        try {
          const response = await fetch('https://api.ipify.org?format=json')
          const data = await response.json()
          ipAddress = data.ip
        } catch (error) {
          console.warn('Could not fetch IP address:', error)
        }
        // Rescind TOS agreement
        const agreementData = {
          time: new Date().toISOString(),
          ipAddress: ipAddress,
          version: '1.0',
        }
        if (token?.access_token) {
          await rescindTos(userId, token.access_token, agreementData)
          // console.log('TOS agreement rescinded')
        } else {
          console.warn('No access token available, only rescinding from local storage')
        }
      } catch (error) {
        console.warn('Failed to rescind TOS, continuing with local rescind:', error)
      }

      // console.log('TOS agreement rescinded successfully')
      fusionOidc.logout()
    } catch (error) {
      console.error('Error rescinding TOS agreement:', error)
      fusionOidc.logout() // Still log out even if there was an error
    } finally {
      setIsRescinding(false)
    }
  }

  if (!user) {
    return (
      <CDropdown variant="nav-item">
        <CDropdownToggle placement="bottom-end" caret={false}>
          <CIcon icon={cilList} size="lg" />
        </CDropdownToggle>
        <CDropdownMenu className="pt-0" placement="bottom-end">
          <CDropdownHeader className="bg-light fw-semibold py-2">Account</CDropdownHeader>
          <CDropdownItem onClick={() => navigate('/login')}>
            <CIcon icon={cilUser} className="me-2" />
            Log in
          </CDropdownItem>
        </CDropdownMenu>
      </CDropdown>
    )
  }
  const profileUrl = fusionOidc.oidcSettings.authority + '/ui/console/users/me'
  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" caret={false}>
        <CIcon icon={cilList} size="lg" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        {/*
        <CDropdownHeader className="bg-light fw-semibold py-2">Account</CDropdownHeader>
        <CDropdownItem href="#">
          <CIcon icon={cilBell} className="me-2" />
          Updates
          <CBadge color="info" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilEnvelopeOpen} className="me-2" />
          Messages
          <CBadge color="success" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilTask} className="me-2" />
          Tasks
          <CBadge color="danger" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilCommentSquare} className="me-2" />
          Comments
          <CBadge color="warning" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        */}
        <CDropdownHeader className="bg-light fw-semibold py-2">{user.name}</CDropdownHeader>
        <CDropdownItem onClick={fusionOidc.logout}>
          <CIcon icon={cilUser} className="me-2" />
          Log out
        </CDropdownItem>
        <CDropdownItem href={profileUrl}>
          <CIcon icon={cilUser} className="me-2" />
          Profile
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem onClick={handleRescindTos} disabled={isRescinding}>
          <CIcon icon={cilTrash} className="me-2" />
          {isRescinding ? 'Rescinding TOS...' : 'Rescind TOS Agreement'}
        </CDropdownItem>
        {/*
        <CDropdownHeader className="bg-light fw-semibold py-2">Account</CDropdownHeader>
        <CDropdownItem href="#">
          <CIcon icon={cilSettings} className="me-2" />
          Settings
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilCreditCard} className="me-2" />
          Payments
          <CBadge color="secondary" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilFile} className="me-2" />
          Projects
          <CBadge color="primary" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem href="#">
          <CIcon icon={cilLockLocked} className="me-2" />
          Lock Account
        </CDropdownItem>
        */}
      </CDropdownMenu>
    </CDropdown>
  )
}

export default AppHeaderDropdown
